
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import FormBase from '@/components/helper/form-base.vue';
    import ModalView from '@/components/helper/modal-view.vue';
    import Util from '@/lib/util';
    import url from '@/lib/url';
    import ListBase from '@/lib/listbase';
    import Agreement from '@/store/entities/tracing/agreement';

    @Component({
        components: { FormBase, ModalView },
        watch: {
            value: function (val) {
                let obj = (this as any);
                obj.modalShow = val;
                if (val) {
                    obj.agreement = Util.extend(true, {}, this.$store.state.agreement.editModel);
                    obj.initForm();
                }
            },
            modalShow: function (val) {
                if (!val) {
                    this.$emit('input', false);
                } else {
                    (this as any).initForm();
                }
            }
        }
    })

    export default class AgreementForm extends ListBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        agreement: Agreement = new Agreement();
        modalShow: boolean = false;
        tabModel: any = null;
        fileData: string = null;
        url: string = url;
        modalSetting: any = {
            entity: "agreement", 
            titleFull: 'Seguimiento de Protocolo',
            width: "1000px",
            showForm: false
        };
        
        items = [
            this.gItem({ type: 'object', prop: 'zone_id', label: 'Zona', entity: 'zone', required: true, size: 2, onchange: this.changeZone }),
            this.gItem({ type: 'object', prop: 'dealer_id', label: 'Concesionario', entity: 'dealer', required: true, itemText: 'fullname', filterParam: 'zone_id', filterVal: [], size: 3, onchange: this.changeDealer }),
            this.gItem({ type: 'object', prop: 'manufacturer_id', label: 'Marca', entity: 'manufacturer', required: true, size: 3 }),
            this.gItem({ type: 'text', prop: 'reason', label: 'Punto a tratar', required: true, size: 4 }),
            this.gItem({ type: 'text', prop: 'description', label: 'Descripcion', size: 12, required: true}),
            this.gItem({ type: 'date', prop: 'agreement_date', label: 'Fecha de firma del acuerdo', size: 4 }),
            this.gItem({ type: 'date', prop: 'due_date', label: 'Fecha de vencimiento', size: 4 }),
            this.gItem({ type: 'object', prop: 'level_id', label: 'Nivel de cumplimiento', generalType: 'E_LEVELS', size: 4, onchange: this.changeLevel }),
            this.gItem({ type: 'object', prop: 'employees_list', label: 'Responsables', entity: 'dealercontact', itemText: 'fullname', filterParam: 'dealer_id', filterVal: [], size: 12, multiple: true }),
            this.gItem({ type: 'textarea', prop: 'notes', label: 'Comentarios y Observaciones', size: 12 }),
        ]

        get dealer() {
            return this.$store.state.app.dealer;
        }

        get currentState() {
            if (this.agreement.state_id == null) return null;
            return Util.abp.list.getItem(this.agreement.state_id);
        }

        get isDealer() {
            return Util.abp.session.isDealer();
        }

        onFileChange(file) {
            if (file != null) {
                let reader = new FileReader();
                let vm = this;
                reader.onload = (e) => {
                    vm.fileData = (e as any).target.result;
                };
                reader.readAsDataURL(file);
            }
        }

        changeZone(id) {
            this.setItem(this.items, 'dealer_id', 'filterVal', [id]);
            if (!(this.agreement.id > 0))
                this.agreement.dealer_id = null;
            if (this.$refs.entityForm1 != undefined)
                (this.$refs.entityForm1 as any).$refs.dealer_id[0].focus()
        }

        changeDealer(id) {
            this.setItem(this.items, 'employees_list', 'filterVal', [id]);
        }

        changeLevel(id) {
            if (id == undefined) {
                this.agreement.state_id = null;
                return;
            }
            
            let level = Util.abp.list.getItem(id);
            let state = (level.code == 'CO' ? 'CO' :
                (this.agreement.days_remain > 0 ? 'EP' :
                (this.agreement.days_remain == 0 ? 'PC' : 'PV')));
            
            this.agreement.state_id = Util.abp.list.get('E_AGREE', state).id;
        }

        initForm() {

            //this.items.forEach(item => {
            //    item.readonly = true;
            //});

            this.setItem(this.items, 'zone_id', 'disabled', this.isDealer);
            this.setItem(this.items, 'dealer_id', 'disabled', this.isDealer);

            if (this.agreement.id > 0) {
                this.changeZone(this.agreement.zone_id);
                this.changeDealer(this.agreement.dealer_id);
            } else {
                this.changeZone(this.agreement.zone_id);

                let deal = Util.getEntity(this, 'dealer', this.dealer);
                this.agreement.dealer_id = this.dealer;

                if (deal != undefined) {
                    this.agreement.zone_id = deal.zone_id;

                    this.changeZone(this.agreement.zone_id);
                    this.changeDealer(this.agreement.dealer_id);
                }
            }

            if (this.$refs.fileInput != undefined)
                (this.$refs.fileInput as any).reset();
        }

        async save() {
            if ((this.$refs.entityForm1 as any).validate()) {
                let model = Util.extend(true, {}, this.agreement);
                model.fileData = this.fileData;

                await this.$store.dispatch({
                    type: 'agreement/' + (this.agreement.id > 0 ? 'update' : 'create'),
                    data: model
                });
                this.$emit('save-success');
                this.cancel();
                if (this.agreement.id > 0)
                    Util.abp.notify.success(this, 'El Seguimiento de acuerdo actualizado!');
                else
                    Util.abp.notify.success(this, 'El Seguimiento de acuerdo ha sido registrado!');
            }
        }

        cancel() {
            this.$emit('input', false);
        }

        async mounted() {
        }

        async created() {
        }
    }
